import { Button, Modal, ModalActions } from '@braskai/ui-kit';

import { useInterfaceLanguage } from '@/shared/i18n';
import { ModalHeaderDefault } from '@/shared/ui/modal';

type DeleteConfirmationModalProps = {
  isLoading: boolean;
  isOpen: boolean;
  onCancel: () => void;
  onDelete: () => void;
};

export const DeleteConfirmationModal = ({ isLoading, isOpen, onCancel, onDelete }: DeleteConfirmationModalProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <Modal open={isOpen} size="xs" onClose={onCancel}>
      <ModalHeaderDefault
        title={t('teamspace.delete.title')}
        style={{
          paddingBottom: 0,
        }}
        subtitle={t('teamspace.delete.subtitle')}
        onClose={onCancel}
      />
      <ModalActions>
        <Button
          data-testid="delete-confirmation-modal-cancel"
          size="lg"
          variant="outlined"
          fullWidth
          onClick={onCancel}
        >
          {t('teamspace.action.cancel')}
        </Button>
        <Button
          data-testid="delete-confirmation-modal"
          isLoading={isLoading}
          size="lg"
          variant="error"
          fullWidth
          onClick={onDelete}
        >
          {t('teamspace.action.delete')}
        </Button>
      </ModalActions>
    </Modal>
  );
};
